export default __webpack_public_path__ + "geburtstag-teaser-03.94f29316a81289192bb9bfd0b110599d.png";